export const informationConstants = {
    INFORMATION_SELECTED: 'INFORMATION_SELECTED'
  }